import { EPISODE, HEALTH_PLAN, PLAN_TYPE } from 'constants/classifications';

export function classificationTitle(type: string) {
  switch (type) {
    case HEALTH_PLAN:
      return 'Plan';
    case PLAN_TYPE:
      return 'Plan Type';
    case EPISODE:
      return 'Episode Type';
    default:
      return 'Classification';
  }
}

export const classificationPageTitle = (type: string) => {
  return classificationTitle(type).concat('s');
};
